import { render, staticRenderFns } from "./add-name.vue?vue&type=template&id=68cc7c0c"
import script from "./add-name.vue?vue&type=script&lang=js"
export * from "./add-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports